const Subtitle = ({children}) => <p tw="text-gray-400 text-sm">{children}</p>

export default Subtitle
